/*
 * @Description: 多导航标签配置
 */
export default {
  clientId: 'longfor', // 当前系统的id
  max: 20, // 最多可以缓存多少组件实例（不包括固定路由）

  // 固定的路由信息
  fixedRoute: [
    {
      path: '/home/index',
      name: 'home-index',
      params: {},
      query: {},
      hash: '',
      fullPath: '/home/index',
      meta: {
        authCodes: [],
        icon: 'menu-home',
        hideBreadcrumb: true,
        title: '首页',
      },
    }
  ],
  fixedViews: ['/home/index'], // 固定的路由如果需要被缓存，这里设置上对应页面组件的name
};
